module.exports = __webpack_public_path__ + "img/5 carmen-vaca-circulo.97df8431.png";